import Head from 'next/head';
import PropTypes from 'prop-types';

import { markup } from 'lib/utils';

const SchemaJsonLd = ({ id, schema }) => (
  <Head>
    <script
      dangerouslySetInnerHTML={markup(JSON.stringify(schema))}
      id={`jsonld-${id}`}
      type="application/ld+json"
    />
  </Head>
);

SchemaJsonLd.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  schema: PropTypes.shape().isRequired,
};

export default SchemaJsonLd;
